import React, {Component} from 'react';
import * as func from "../../../utils/functions";
import {MESSAGE, EDIT_MODE, BASE_PATH} from "../../../wpconfig"
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import ReactPaginate from "react-paginate";

class AuthorityPopup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			param: {
				'record_per_page': 5,
				'term_name': ['표제어'],
				'term_status': ['publish'],
				current_page: 1,
				ks : this.props.ks,
			},
			field: 'authority',
			records: [],
			totalRecords: 0,
			totalPage: 0,
			pkKey: 'authority_id',
			action: 'admin/authority_list',
			record: {
				scopus_id: "",
				position_name: "",
				memo: "",
				authority_id: '',
				term_parent: 0,
				kci_id: "",
				term_status: "publish",
				authority_term: "",
				// authority_name: "",
				term_type: "heading",
				position_type: "",
				wos_id: ""
			}
		}

		this._handleKeyDown = this._handleKeyDown.bind(this);
		this.onChange = this.onChange.bind(this);
		this.search = this.search.bind(this);
	}

	componentDidMount() {
		if (this.props.showSearchPopup) {
			let param = this.state.param
			// param.ks = this.props.ks;
			// this.setState({param: param})
			func.getData(this.state.action, param).then((response) => {
				this.setState({
					isInit: true,
					records: response.records,
					facet: response.facet,
					totalRecords: response.pageInfo.totalResults,
					totalPage: response.pageInfo.totalPage,
				})
			});
			// this.ks.value = this.props.title;
		}
	}

	// change = () => {
	// 	let record = this.state.record;
	// 	record[event.target.name] = event.target.value;
	// 	if (event.target.name === 'position_type')
	// 		record['position_name'] = this.props.categoryName[event.target.value];
	// 	this.props.onUpdate(this.props.arrIndex, record, true);
	// }

	onChange = (event) => {
		event.preventDefault();

		let param = this.state.param
		param.ks = event.target.value;
		this.setState({param: param})
		this.forceUpdate()
	}

	search = (event) => {
		event.preventDefault();

		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})
		});
	}

	set = (record) => {
		this.props.set(record)
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param.current_page = paged;

		func.getData(this.state.action, param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
				param: param
			})
		});
	}

	change = () => {
		let record = this.state.record;
		record[event.target.name] = event.target.value;
		this.setState({record: record})
		this.forceUpdate()
	}

	_handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			this.search(event)
		}
	}

	onSave = (event) => {
		event.preventDefault()

		let record = this.state.record;
		record.term_name = record.term_type === 'heading' ? '표제어' : '관계어';

		if (this.authority_term.value === '') {
			this.authority_term.focus();
		} else {
			func.updateData("admin/" + this.state.field + "/insert", record).then((response) => {
				if (response.code === 'ok') {
					// record[this.props.pkKey] = response[this.props.pkKey];
					// this.props.onUpdate(this.props.arrIndex, record, true);
					this.setState({
						record: {
							scopus_id: "",
							// position_name: "",
							memo: "",
							authority_id: '',
							// term_parent: 0,
							kci_id: "",
							term_status: "publish",
							authority_term: "",
							term_name : '',
							// authority_name: "",
							term_type: "heading",
							position_type: "",
							wos_id: ""
						}
					});
					let param = this.state.param
					param.ks = '';
					param.current_page = 1;
					this.setState({param: param})
					func.getData(this.state.action, param).then((response) => {
						this.setState({
							isInit: true,
							records: response.records,
							facet: response.facet,
							totalRecords: response.pageInfo.totalResults,
							totalPage: response.pageInfo.totalPage,
						})
						this.forceUpdate()
					});
					this.ks.value = '';
					this.forceUpdate();
					this.props.showMessage('추가 되었습니다.');
				} else {
					this.props.showMessage('저장 실패 : ' + response.message);
				}
			});
		}
	};

	render() {
		if (!this.props.showSearchPopup)
			return ''
		return (
			<div id="search_heading_term" className="modal-mask modal-rm">
				<div className="modal-wrapper">
					<div className="modal-container modal-content">
						<div className="modal-header"><h1 className="modal-title">표제어 선택</h1>
							<button type="button" className="close" onClick={() => this.props.setSearchPopup(false)}>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="row">
								<div className="col">
									<div className="form-group form-inline">
										<input type="text" value={this.state.param.ks}
										       name="ks"
										       ref={(ref) => this.ks = ref}
										       onChange={this.onChange}
										       onKeyUp={this._handleKeyDown}
										       placeholder="표제어 검색 결과" className="form-control form-control-sm"/>
										<button type="button" className="btn btn-primary btn-sm save ml-1"
										        onClick={this.search}>검색
										</button>
									</div>
									<table className="wp-list-table widefat fixed table modal-terms">
										<thead>
										<tr>
											<th scope="col" style={{width : "70px"}}>ID</th>
											<th scope="col" style={{width : "62px"}}>유형</th>
											<th scope="col">표제어</th>
										</tr>
										</thead>
										<tbody>
										{this.state.records.map((record, index) => {
											return (
												<tr key={'p' + record.authority_id} className="list-row" onClick={() => this.set(record)}>
													<td>{record.authority_id}</td>
													<td>{record.term_type === 'heading' ? '표제어' : '관계어'}</td>
													<td>{record.authority_term}</td>
												</tr>
											)
										})}
										{this.state.records.length <= 0 &&
										<tr className="list-row">
											<td colSpan={4}>검색 결과가 없습니다.</td>
										</tr>
										}
										</tbody>
									</table>

									<ReactPaginate
										forcePage={Number(this.state.param.current_page) - 1}
										pageCount={this.state.totalPage}
										marginPagesDisplayed={2}
										pageRangeDisplayed={2}
										onPageChange={this.handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										pageClassName={'page-item'}
										pageLinkClassName={'page-link'}
										previousClassName={'page-item page-item-prev'}
										previousLinkClassName={'page-link'}
										nextClassName={'page-item page-item-next'}
										nextLinkClassName={'page-link'}
									/>
								</div>
								<div className="col">
									<div className="form-group"><label htmlFor="term">용어</label>
										<input type="text" name="authority_term"
										       ref={(ref) => this.authority_term = ref}
										       value={this.state.record.authority_term}
										       onKeyDown={this._handleKeyDown}
										       onChange={this.change} className="form-control form-control-sm"/>
									</div>
									<div className="form-group">
										<div><label>포지션</label></div>
										<div>
											{this.props.category.map((type, i) => {
												return (
													<div key={type.code_id} className="form-check form-check-inline">
														<input type="checkbox" id={"pposition-" + type.code_id} className="term-position"
														       name="position_type"
														       value={type.code_id}
														       checked={this.state.record.position_type === type.code_id}
														       onChange={this.change}/>
														<label htmlFor={"pposition-" + type.code_id}
														       className="form-check-label">{type.code_name}</label>
													</div>
												)
											})}
										</div>
									</div>
									<div className="form-group form-row">
										<div className="col"><label htmlFor="term">WOS ID</label>
											<input type="text" name="wos_id" onChange={this.change} value={this.state.record.wos_id}
											       className="form-control form-control-sm"/>
										</div>
										<div className="col"><label htmlFor="term">SCOPUS ID</label>
											<input type="text" name="scopus_id" onChange={this.change} value={this.state.record.scopus_id}
											       className="form-control form-control-sm"/>
										</div>
										<div className="col"><label htmlFor="term">KCI ID</label>
											<input type="text" name="kci_id" onChange={this.change} value={this.state.record.kci_id}
											       className="form-control form-control-sm"/>
										</div>
									</div>
									<div className="submit inline-edit-save">
										<button type="button" className="button button-primary save alignright" onClick={this.onSave}>추가</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default AuthorityPopup;